// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"q-i2N"};